import { useQuery, UseQueryOptions } from "@tanstack/react-query";

import { DescribeOpportunityFieldsResponse } from "lib/generated/integration-api";
import { useIntegrationApi } from "lib/integrationApiContext";

type QueryKey = [string];

export function useViewOpportunityFieldsProvider(
  options?: UseQueryOptions<
    DescribeOpportunityFieldsResponse,
    unknown,
    DescribeOpportunityFieldsResponse,
    QueryKey
  >,
) {
  const api = useIntegrationApi();
  return useQuery(
    ["integrationOpportunityFields"],
    () => {
      return api.describeOpportunityFields();
    },
    options,
  );
}
